// extracted by mini-css-extract-plugin
module.exports = {"inherit":"getDecoration_inherit__Tb2_d","none":"getDecoration_none__2h6w6","underline":"getDecoration_underline__1iwgN","lineThrough":"getDecoration_lineThrough__1XCV_"};